import { createContext } from "react";
import { th } from "./dictionary/th";
import { en } from "./dictionary/en";

export const i18n = {
  th,
  en
};
export default createContext(i18n.th);
